<mat-sidenav-container id="app-sidenav-container">
  <mat-sidenav #sidenav [mode]="'over'">
    <div id="sidenav-menu" fxLayout="column">
      <div class="menu-header">
        <div class="logo">
          <img src="/assets/img/menu-sema-logo.svg" />
        </div>
        <hr />
      </div>
      <div class="menu-main" fxFlex="auto">
        <mat-nav-list [disableRipple]="true">
          <a mat-list-item [routerLink]="['/uploads']" routerLinkActive="router-link-active">
            <img class="menu-item" src="/assets/img/icon-menu/iconMenu_grayscale/upload_grayscale.svg" />
            <img class="menu-item-active" src="/assets/img/icon-menu/iconMenu_colorHovering/upload_colorHovering.svg" />
          </a>

          <a
            mat-list-item
            [routerLink]="['/alertas/consulta']"
            routerLinkActive="router-link-active"
          >
            <img
              class="menu-item"
              src="/assets/img/icon-menu/iconMenu_grayscale/consultaEvisualizacao_grayscale.svg"
            />
            <img
              class="menu-item-active"
              src="/assets/img/icon-menu/iconMenu_colorHovering/consultaEvisualizacao_colorHovering.svg"
            />
          </a>
          <a
            mat-list-item
            [routerLink]="['/alertas/validacao']"
            routerLinkActive="router-link-active"
          >
            <img
              class="menu-item"
              src="/assets/img/icon-menu/iconMenu_grayscale/edicaoEvalidacao_grayscale.svg"
            />
            <img
              class="menu-item-active"
              src="/assets/img/icon-menu/iconMenu_colorHovering/edicaoEvalidacao_colorHovering.svg"
            />
          </a>
          <a
            mat-list-item
            [routerLink]="['/alertas/gestao']"
            routerLinkActive="router-link-active"
          >
            <img
              class="menu-item"
              src="/assets/img/icon-menu/iconMenu_grayscale/gestaoDeAlertas_grayscale.svg"
            />
            <img
              class="menu-item-active"
              src="/assets/img/icon-menu/iconMenu_colorHovering/gestaoDeAlerdas_colorHovering.svg"
            />
          </a>
          <a
            [disabled]="true"
            mat-list-item
            [routerLink]="['/alertas/fiscalizacao']"
            routerLinkActive="router-link-active"
          >
            <img
              class="menu-item"
              src="/assets/img/icon-menu/iconMenu_grayscale/fiscalizacao_grayscale.svg"
            />
            <img
              class="menu-item-active"
              src="/assets/img/icon-menu/iconMenu_colorHovering/fiscalizacao_colorHovering.svg"
            />
          </a>
          <!--
          <hr />
          <a mat-list-item [routerLink]="['6']" routerLinkActive="router-link-active">
            <img class="menu-item" src="/assets/img/icon-menu/iconMenu_grayscale/dashboard_grayscale.svg" />
            <img class="menu-item-active"
            src="/assets/img/icon-menu/iconMenu_colorHovering/dashboard_colorHovering.svg" />
          </a>
          <a mat-list-item [routerLink]="['7']" routerLinkActive="router-link-active">
            <img class="menu-item" src="/assets/img/icon-menu/iconMenu_grayscale/administracao_grayscale.svg" />
            <img class="menu-item-active"
            src="/assets/img/icon-menu/iconMenu_colorHovering/administracao_colorHovering.svg" />
          </a>
        -->
        </mat-nav-list>
      </div>
      <div class="menu-botton">
        <a
          mat-list-item
          [routerLink]="['user']"
          routerLinkActive="router-link-active"
        >
          <img
            class="menu-item"
            src="/assets/img/icon-menu/iconMenu_grayscale/user_grayscale.svg"
          />
          <img
            class="menu-item-active"
            src="/assets/img/icon-menu/iconMenu_colorHovering/user_colorHovering.svg"
          />
        </a>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content style="overflow: hidden;">
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
